<button *ngIf="showBotton" id="googleBtn" type="button" class="btn btn-lg btn-google w100" [disabled]="loading">
    <span>{{'SHARED.login.ctaLogin' | translate}}</span>
    <span> {{ 'GENERAL.with' | translate }} </span>
    <span>Google</span>
</button>

<!-- <div id="google-container" #googleSignContainer>

</div> -->

<div id="prompt-parent"></div>